
import * as z from "zod";
import { isValidDate } from "@/utils/validation/dateValidation";

// Schema for form validation
export const applicationFormSchema = z.object({
  fullName: z.string().min(2, {
    message: "Le nom doit contenir au moins 2 caractères",
  }),
  tiktokHandle: z.string().min(1, {
    message: "Nom d'utilisateur TikTok requis",
  }),
  email: z.string().email({
    message: "Email invalide",
  }),
  phoneNumber: z.string().min(6, {
    message: "Numéro de téléphone invalide",
  }),
  birthDate: z.string().refine(isValidDate, {
    message: "Format invalide (JJ/MM/AAAA) ou âge minimum 18 ans requis",
  }),
  creativeApproach: z.string().optional(),
  motivation: z.string().optional(),
  acceptedContact: z.boolean().refine(value => value === true, {
    message: "Vous devez accepter d'être contacté",
  }),
});

export type ApplicationFormValues = z.infer<typeof applicationFormSchema>;
